export const ACTION_PLAN = 'ACTION_PLAN';
export const PREMIUM = 'PREMIUM';
